<div class="d-flex flex-column">
  <div class="d-flex justify-content-center">
    <div class="spinner-border text-primary m-5" style="width: 7vmax; height: 7vmax" role="status"></div>
  </div>
  <div class="d-flex justify-content-center text-primary m-5">Loading...</div>
</div>
